import _classCallCheck from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
var LuxonError =
/*#__PURE__*/
function (_Error) {
  _inherits(LuxonError, _Error);

  function LuxonError() {
    _classCallCheck(this, LuxonError);

    return _possibleConstructorReturn(this, _getPrototypeOf(LuxonError).apply(this, arguments));
  }

  return LuxonError;
}(_wrapNativeSuper(Error));
/**
 * @private
 */


export var InvalidDateTimeError =
/*#__PURE__*/
function (_LuxonError) {
  _inherits(InvalidDateTimeError, _LuxonError);

  function InvalidDateTimeError(reason) {
    _classCallCheck(this, InvalidDateTimeError);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidDateTimeError).call(this, "Invalid DateTime: ".concat(reason.toMessage())));
  }

  return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */

export var InvalidIntervalError =
/*#__PURE__*/
function (_LuxonError2) {
  _inherits(InvalidIntervalError, _LuxonError2);

  function InvalidIntervalError(reason) {
    _classCallCheck(this, InvalidIntervalError);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidIntervalError).call(this, "Invalid Interval: ".concat(reason.toMessage())));
  }

  return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */

export var InvalidDurationError =
/*#__PURE__*/
function (_LuxonError3) {
  _inherits(InvalidDurationError, _LuxonError3);

  function InvalidDurationError(reason) {
    _classCallCheck(this, InvalidDurationError);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidDurationError).call(this, "Invalid Duration: ".concat(reason.toMessage())));
  }

  return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */

export var ConflictingSpecificationError =
/*#__PURE__*/
function (_LuxonError4) {
  _inherits(ConflictingSpecificationError, _LuxonError4);

  function ConflictingSpecificationError() {
    _classCallCheck(this, ConflictingSpecificationError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConflictingSpecificationError).apply(this, arguments));
  }

  return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */

export var InvalidUnitError =
/*#__PURE__*/
function (_LuxonError5) {
  _inherits(InvalidUnitError, _LuxonError5);

  function InvalidUnitError(unit) {
    _classCallCheck(this, InvalidUnitError);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidUnitError).call(this, "Invalid unit ".concat(unit)));
  }

  return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */

export var InvalidArgumentError =
/*#__PURE__*/
function (_LuxonError6) {
  _inherits(InvalidArgumentError, _LuxonError6);

  function InvalidArgumentError() {
    _classCallCheck(this, InvalidArgumentError);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidArgumentError).apply(this, arguments));
  }

  return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */

export var ZoneIsAbstractError =
/*#__PURE__*/
function (_LuxonError7) {
  _inherits(ZoneIsAbstractError, _LuxonError7);

  function ZoneIsAbstractError() {
    _classCallCheck(this, ZoneIsAbstractError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZoneIsAbstractError).call(this, "Zone is an abstract class"));
  }

  return ZoneIsAbstractError;
}(LuxonError);